import api from './apiClient';

export const sponsorsAPI = {
  getSponsors: async (raceId) => {
    const response = await api.get(`/api/races/${raceId}/sponsors`);
    return response.data;
  },
  createSponsor: async (raceId, sponsorData) => {
    const response = await api.post(`/api/races/${raceId}/sponsors`, sponsorData);
    return response.data;
  },
  updateSponsor: async (id, sponsorData) => {
    const response = await api.post(`/api/sponsors/${id}`, sponsorData);
    return response.data;
  },
  deleteSponsor: async (id) => {
    await api.post(`/api/sponsors/${id}/delete`, {});
  },
  uploadImage: async (file) => {
    const formData = new FormData();
    formData.append('image', file);
    const response = await api.post('/api/sponsors/upload', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return response.data;
  },
};
